module.exports = __webpack_public_path__ + "img/img53.3a4ad218.svg";